import { Toast } from "vant";
import { onNeedAuth, onNeedJumpAuthTipPage } from "./hooks";
import { getToken } from "@/utils/auth";
import { getTenantBaseConfig } from "@/domainMapping";

export const onRequest = (config) => {
  // Do something before request is sent
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  config.headers["Pragma"] = "no-cache";
  config.headers["Accept"] = "application/json";
  config.headers["Authorization"] = `Bearer ${getToken()}`;
  config.headers["x-cus-tenant-id"] = getTenantBaseConfig().brandId;
  return config;
};

export const onRequestOld = (config) => {
  // Do something before request is sent
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  config.headers["Pragma"] = "no-cache";
  config.headers["Accept"] = "application/json";
  config.headers["Authorization"] = `Bearer ${getToken()}`;
  config.headers["x-cus-tenant-id"] = getTenantBaseConfig().brandId;
  return config;
};

export const onResolve = (instance, response) => {
  const data = response ? response.data : {};
  if (data.code == "100004") {
    onNeedJumpAuthTipPage();
  }
  switch (data.errorCode) {
    case "SUCCESS":
      return data.data;
  }
  if (data.message && data.errorCode !== 'SUCCESS_IS_SNAPSHOTUSER') {
    Toast(data.message);
  }
  return Promise.reject(data || response);
};

export const onReject = (err) => {
  // 这里是返回状态码不为200时候的错误处理
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = "请求错误";
        break;

      case 401:
        onNeedAuth();
        err.message = "未授权，请登录";
        break;

      case 403:
        err.message = "拒绝访问";
        break;

      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`;
        break;

      case 408:
        err.message = "请求超时";
        break;

      case 500:
        err.message = "服务器内部错误";
        break;

      case 501:
        err.message = "服务未实现";
        break;

      case 502:
        err.message = "网关错误";
        break;

      case 503:
        err.message = "服务不可用";
        break;

      case 504:
        err.message = "网关超时";
        break;

      case 505:
        err.message = "HTTP版本不受支持";
        break;

      default:
    }
  }

  return Promise.reject(err);
};
